const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

const PIXEL_ID = '7047bd2f-a402-4516-a1f2-ff1b333d5785'

const snapchatPixelScript = `
(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
  {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
  a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
  r.src=n;var u=t.getElementsByTagName(s)[0];
  u.parentNode.insertBefore(r,u);})(window,document,
  'https://sc-static.net/scevent.min.js');
  snaptr('init', '${PIXEL_ID}');
  snaptr('track', 'PAGE_VIEW');
`

exports.onClientEntry = () => {
  const snapchatPixelInit = () => {
    const script = document.createElement('script')
    script.id = 'gatsby-plugin-snapchat-pixel'
    const inlineScript = document.createTextNode(snapchatPixelScript)
    script.appendChild(inlineScript)
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  window.removeEventListener(cookieAcceptEventName, snapchatPixelInit)
  window.addEventListener(cookieAcceptEventName, snapchatPixelInit, {
    once: true,
  })

  if (hasAcceptedCookies('analytics')) snapchatPixelInit()
}
